import { render, staticRenderFns } from "./StatsComponent.vue?vue&type=template&id=96813dfc"
import script from "./StatsComponent.vue?vue&type=script&lang=js"
export * from "./StatsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports